import * as React from 'react';

import { 
    makeLayout, makeLayoutSlot, 
    makePlugin, makePluginSlot,
    makeController, effectGetter, Effects,
    makeEntry, 
    IControllerContext, IPluginContext, ISlotContext, 
} from '../../../core/Slot';

export type Value = { display: string, value: string };
export type Data = Value[];
export type InnerData = (Value & { checked: boolean })[];

export type SelfValue = Value[];

export const emptyValue: SelfValue = [];

export const URI = 'GroupButtonMultiple';
export type URI = typeof URI;
declare module '../../../core/Slot' {
    interface URItoKind {
        [URI]: {
            slots: {
                inner: {
                    innerProps: {
                    },
                    outerProps: {
                        className?: string,
                    },
                },
                item: {
                    innerProps: {
                        index: number,
                    },
                    outerProps: {
                        children: (x: Value) => React.ReactNode,
                        className?: string,
                    },
                }
            },
            controllers: {
                main: {
                    name: string,
                    getData: () => InnerData[],
                    getCurrentValue: () => Data,
                    changeValue: (x: InnerData) => void,
                    modifyValue: (f: (d: InnerData) => InnerData) => void,
                    batch: () => void,
                },
                cursor: {
                    get: () => number,
                    set: (n: number) => void,
                    modify: (f: (n: number) => number) => void,
                },
            },
            effects: ['changeValue', 'cursorMove'],
            plugins: {},
        },
    }
}

const SlotContext = React.createContext({} as ISlotContext<URI>);
const ControllerContext = React.createContext({} as IControllerContext<URI>);
const EffectContext = React.createContext({} as Effects<URI>);
const PluginContext = React.createContext({} as IPluginContext<URI>);

export const Entry = makeEntry({
    SlotContext,
    ControllerContext,
    EffectContext,
    PluginContext,
    initSlots: {
        inner: {
            props: {
                children: () => null,
            },
            component: ({ children }) => {
                return (
                <React.Fragment>{children}</React.Fragment>
                );
            },
        },
        item: {
            props: {
                value: () => [],
                children: () => () => null,
                index: () => 0,
            },
            component: ({ children }) => {
                return (
                    <React.Fragment>{children}</React.Fragment>
                );
            },
        }
    },
    initControllers: {
        main: {
            name: 'empty',
            getData: () => [],
            getCurrentValue: () => [],
            changeValue: () => {},
            modifyValue: () => {},
            batch: () => {},
        },
        cursor: {
            get: () => 0,
            set: () => {},
            modify: () => {},
        },
    },
    initEffect: ['changeValue', 'cursorMove'],
});

export const Layout = makeLayout(SlotContext);
export const [useGetter, useSetter] = makeController(ControllerContext);
export const slot = makeLayoutSlot(SlotContext);
export const useEffect = effectGetter(EffectContext);
export const Plugin = makePlugin(PluginContext);
export const plugin = makePluginSlot({ PluginContext, SlotContext });
